module.exports = __webpack_public_path__ + "static/media/redtiger.576fbd0f.svg";